<template>
    <div>
        <template v-if="isMerklistenView == false">
            <template v-for="(Angebot, index) in slicedAngebote[currentPage-1]" >
                <single-item :Angebot="Angebot" v-bind:key="Angebot.persistence_object_identifier"  :isAufMerkliste="aufMerkliste(Angebot.persistence_object_identifier)" :isLast="isLastPaginated(index)"/>
            </template>
            <template v-if="isReady == true">
                <template v-if="slicedAngebote[currentPage-1].length == 0">
                    <h3>Es gibt keine Angebote mit Ihren Suchkriterien</h3>
                </template>
            </template>

            <nav class="pagination pt-4 d-flex justify-content-center" v-if="slicedAngebote.length > 0">
                <ul class="d-flex pl-0">
                    <!--<li v-on:click="prevPage" v-bind:class="{ disabled: currentPage == 1 }">Vorherige Seite</li> -->
                    <li v-for="index in pageCount" v-on:click="goToPage(index)" v-bind:class="{ active: currentPage == index }" v-if="index >= ((pageRange) - itemsPerPage) && index <= pageRange">{{index}}</li>
                    <!-- <li v-on:click="nextPage" v-bind:class="{ disabled: currentPage == pageCount }">Nächste Seite</li> -->
                </ul>
            </nav>
        </template>
        <template v-else>
            <template v-for="(Angebot, index) in Angebote" >
                <single-item  :Angebot="Angebot" v-bind:key="Angebot.persistence_object_identifier"  :isAufMerkliste="aufMerkliste(Angebot.persistence_object_identifier)" :isLast="isLast(index)"/>
            </template>
        </template>
        <Show :settings="Settings" :modalActive="false" :listOrte="listOrte" ></Show>
        <Lightbox></Lightbox>
    </div>
</template>

<script>

import { mdbIcon, mdbSpinner } from 'mdbvue';
import { mdbDatatable, mdbPagination, mdbPageItem, mdbPageNav } from 'mdbvue';
import settings from '@/components/Settings.json';
import AngebotService from "@/services/AngebotService";
import EmailService from "@/services/EmailService";
import singleItem from '@/components/angebot/mieter/AngebotItem';
import SettingService from '@/services/SettingsService';
import Lightbox from "@/components/Lightbox";
import Show from "@/components/angebot/mieter/Show";
export default {
  name: "Angebote",
    components: {
      mdbIcon,
        mdbDatatable,
        singleItem,
        mdbSpinner,
        mdbPagination,
        mdbPageItem,
        mdbPageNav,
        Show,
        Lightbox
  },
  data() {
    return {
        arten: [],
        listOrte: [],
        Texte: "",
        currentPage: 1,
        itemsPerPage: 10,
        pagesAtOnce: 10,
        componentLoaded: false,
        slicedAngebote: [],
        pageCount: 0,
        pageRange: 10,
        isReady: false,
        Settings: settings
    };
  },
  props: {
        Angebote: Array,
        user: Object,
        isLoading: 1,
          isMerklistenView: {
              type: Boolean,
              required: false,
              default: false,
          }
  },
  methods: {
      nextPage(){
          this.currentPage++;
          this.pagination();
      },
      prevPage(){
          this.currentPage--;
          this.pagination();
      },
      goToPage(index){
          this.currentPage = index;
      },
      pagination(){
          if(this.currentPage == this.pagesAtOnce / 2){
          }
      },
      openModal(id) {
            this.$parent.showModal(id)
      },
      closeModal(){
          this.modalActive = false;
      },
      emitChange(){
            this.$parent.refreshAngebote();
      },
      emitChangeMerkliste(){
          this.$parent.getMerkliste();
      },

      getMerkliste(){
          let merklisteIds = [];
          let merkliste = JSON.parse(this.$store.getters.merkliste);

          for (let i = 0; i < merkliste.length; i++){
              merklisteIds.push(merkliste[i]["persistence_object_identifier"]);
          }

          return merklisteIds;
      },
      aufMerkliste(id){
          let value =  this.merkliste.indexOf(id);
          if(value >= 0){
              return true
          } else {
              return false
          }
      },

      selectOrt(key) {
        if(!key){return}
          key = key.replace(/ /g,'');
          this.listOrte.forEach(option => {
              if(option.value == key){
                  option.selected = true;
                  this.Angebot.ort = option.text;
              }
          });
      },
      isLast(index){
          if(index == this.Angebote.length -1){
              return true
          } else {
              return false
          }
      },
      isLastPaginated(index){
          if(index == this.slicedAngebote.length -1){
              return true
          } else {
              return false
          }
      },
      getPageCount(){
          let l = this.Angebote.length,
              s = this.itemsPerPage;
          return Math.floor(l/s);
      }

  },
    mounted() {
        this.listOrte = this.$store.getters.places;
        this.componentLoaded = true;
        this.arten = settings.Settings[1][this.$store.getters.lang][0].Zimmerarten;

    },
    watch:{
        Angebote:{
            handler: function (val, oldVal) {
                this.pageCount = Math.ceil(this.Angebote.length/this.itemsPerPage);
                this.currentPage = 1;
                let angebotWrapper = this.Angebote.slice(0);
                this.slicedAngebote = [];
                while (angebotWrapper.length > 0){
                    this.slicedAngebote.push(angebotWrapper.splice(0, this.itemsPerPage));
                }

            }
        },
        currentPage:{
            handler: function (val, oldVal) {
                let center = this.itemsPerPage / 2;
                if(val > center){
                    if(val >= this.slicedAngebote.length - center +2){

                    } else {
                        this.pageRange = (val + this.itemsPerPage) - center;
                    }
                }
            }
        }
    },
    computed:{
        merkliste(){
          if(this.$store.getters.merkliste){
            let merklisteIds = [];
            let merkliste = JSON.parse(this.$store.getters.merkliste);
            if(merkliste){
              for (let i = 0; i < merkliste.length; i++){
                merklisteIds.push(merkliste[i]["persistence_object_identifier"]);
              }
            }
            return merklisteIds;
          }
          return false
        }
    }
}

</script>
